import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { InputText } from '@knockrentals/knock-shared-web';
import { formatMaxIncome, parseMaxIncome } from './utils';

export const MAX_INCOME_ARIA_LABEL = 'maximum income';

const MaxIncome = ({
  className,
  clearValidationErrorMessage,
  errorMessage,
  maxIncome,
  maxIncomeOnChange,
}) => {
  const [cursorPosition, setCursorPosition] = useState({
    selectionEnd: null,
    selectionStart: null,
  });
  const [isEditing, setIsEditing] = useState(false);

  const incomeRef = useRef();

  const hasCursorPositionChanged =
    incomeRef.current &&
    cursorPosition.selectionEnd !== null &&
    cursorPosition.selectionStart !== null;

  useEffect(() => {
    if (hasCursorPositionChanged) {
      incomeRef.current.setSelectionRange(
        cursorPosition.selectionStart,
        cursorPosition.selectionEnd
      );
    }

    setCursorPosition({
      selectionEnd: null,
      selectionStart: null,
    });
  }, [
    cursorPosition.selectionEnd,
    cursorPosition.selectionStart,
    hasCursorPositionChanged,
  ]);

  const handleOnBlur = (e) => {
    setIsEditing(false);

    setCursorPosition({
      selectionEnd: null,
      selectionStart: null,
    });
  };

  const handleOnChange = (e) => {
    const { selectionEnd, selectionStart, value } = e.target;
    const maxIncome = parseMaxIncome(value);

    const offset = value.length - maxIncome.length;

    setCursorPosition({
      selectionEnd: selectionEnd - offset,
      selectionStart: selectionStart - offset,
    });

    maxIncomeOnChange(maxIncome);
  };

  const handleOnFocus = () => {
    setIsEditing(true);

    if (errorMessage) {
      clearValidationErrorMessage();
    }
  };

  return (
    <InputText
      aria-label={MAX_INCOME_ARIA_LABEL}
      className={className}
      error={Boolean(errorMessage)}
      helperText={errorMessage}
      inputRef={incomeRef}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      startIcon={isEditing ? '' : '$'}
      value={isEditing ? maxIncome : formatMaxIncome(maxIncome)}
    />
  );
};

MaxIncome.propTypes = {
  className: PropTypes.string,
  clearValidationErrorMessage: PropTypes.func,
  errorMessage: PropTypes.string,
  maxIncome: PropTypes.string,
  maxIncomeOnChange: PropTypes.func,
};

export default MaxIncome;
